import _Cascader from './Cascader';

import './style';

export const Cascader = _Cascader;
export type { CascaderProps } from './Cascader';

export default Cascader;
